<template lang="pug">
    v-dialog(v-model="value" scrollable max-width=640 @click:outside="closeDialog()")
        v-card 
            v-card-title.mb-4.text-center {{title}}
            v-card-text
                Alert
                v-form(v-model="formValid" ref="emailform")
                    .field-label 
                        span {{$t('EstimatesAndInvoices.__From')}}
                        span.required *
                    v-select(v-model="senderEmail" solo dense outlined :items="selectEmails")
                    //- v-text-field(v-model="senderEmail" solo dense outlined required :rules="[rules.required, rules.email]")
                    .field-label 
                        span {{$t('EstimatesAndInvoices.__To')}}
                        span.required *
                    v-radio-group(v-model="radioGroup")
                        v-radio(v-if="customer.email && customer.email != ''" :key="1" :value="1" :label="$t(radioSubtitleKey, {customerName:customer.name})") 
                        v-radio(:key="2" :value="2" :label="$t('EstimatesAndInvoices.__OtherContact')") 
                    v-combobox(v-if="radioGroup == 2" v-model="emails" dense solo outlined chips clearable :delimiters="[',']" label="" multiple single-line :error="emailError", :error-messages="emailErrorMsg" @input="checkEmails")
                        template(v-slot:selection="{ attrs, item, select, selected }")
                            v-chip(v-bind="attrs" :input-value="selected" close @click:close="removeEmail(item)" color="primary") {{item}}
                    v-checkbox(v-model="copyEmail" :label="$t('EstimatesAndInvoices.__SendCopy')")

            v-card-actions.justify-center.mb-6
                v-btn.mr-6(rounded dark @click="closeDialog()" color="lightGray" min-width='112') {{$t('ActionOption.__Cancel')}}
                v-btn(rounded dark @click="sendEmail" color="primary"  min-width='112') {{$t('ActionOption.__Send')}}
</template>
<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    radioSubtitleKey: {
      type: String,
      default: ""
    },
    customer: {
      type: Object,
      default: () => {
        return { name: "" }
      }
    },
    confirmAction: {
      type: Function,
      default: () => {}
    },
    category: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      biz: {},
      user: {},
      senderEmail: "",
      selectEmails: [],
      copyEmail: false,
      formValid: false,
      rules: textfieldUtils.rules,
      radioGroup: 1,
      emails: [],
      groupKey: 100,
      emailError: false,
      emailErrorMsg: ""
    }
  },
  methods: {
    removeEmail(item) {
      this.emails.splice(this.emails.indexOf(item), 1)
      this.emails = [...this.emails]
    },
    sendEmail() {
      this.$refs.emailform.validate()

      var receiverEmails = []
      var ccEmails = []
      if (this.radioGroup == 1) {
        receiverEmails = [this.customer.email]
      } else {
        if (!this.checkEmails()) {
          return
        }
        receiverEmails = [...this.emails]
      }
      if (this.copyEmail) {
        ccEmails.push(this.user.email)
      }

      if (this.category == "estimate") {
        this.sendEmailAction("estimates/sendEstimateByEmail", receiverEmails, ccEmails)
      } else if (this.category == "invoice") {
        this.sendEmailAction("invoices/sendInvoiceByEmail", receiverEmails, ccEmails)
        if (this.radioGroup == 1) {
          this.$store.dispatch("invoices/convertToBill", this.id)
        }
      } else if (this.category == "reminder") {
        this.sendEmailAction("invoices/sendInvoiceReminderByEmail", receiverEmails, ccEmails)
      } else if (this.category == "receipt") {
        this.sendEmailAction("transactions/sendReceiptByEmail", receiverEmails, ccEmails)
      }
    },
    sendEmailAction(dispatchKey, receiverEmails, ccEmails) {
      this.$store
        .dispatch(dispatchKey, {
          id: this.id,
          emails: receiverEmails,
          from: this.senderEmail,
          cc: ccEmails
        })
        .then(
          function(response) {
            this.closeDialog()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullySend"))
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    closeDialog() {
      this.$emit("input", false)
      // this.radioGroup = 1
      this.emails = []
      this.senderEmail = this.selectEmails[0]
      this.emailErrorMsg = ""
      this.emailError = false
    },
    checkEmails() {
      if (this.emails.length == 0) {
        this.emailError = true
        this.emailErrorMsg = this.$t("Form.__InvalidEmail")
        return false
      } else {
        this.emailError = false
        this.emailErrorMsg = ""
        return true
      }
    }
  },
  watch: {
    customer(value) {
      if (value.email == "") {
        this.radioGroup = 2
      } else {
        this.radioGroup = 1
      }
    }
  },

  mounted() {
    this.$store.dispatch("global/closeAlert")
    this.biz = this.$store.getters["bizes/biz"]()
    this.user = this.$store.getters["account/user"]()
    this.selectEmails = [this.biz.email, this.user.email]
    this.senderEmail = this.selectEmails[0]
  }
}
</script>
